import stylesheet from './DocumentListItem.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

export class NXTDocumentListItem extends CustomComponent {

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(
            'document-list-item',
        );
        container.innerHTML = `
            <div class="document-information">
                <div class="document-title"></div>
                <div class="document-description"></div>
            </div>
            <div class="document-ctas"></div>
        `;
        this.cloneDefaultSlotContentIntoContainer(container.querySelector('.document-title'));
        this.cloneSlotContentIntoContainer(container.querySelector('.document-description'), 'description');
        this.cloneSlotContentIntoContainer(container.querySelector('.document-ctas'), 'filesize', false);
        this.cloneSlotContentIntoContainer(container.querySelector('.document-ctas'), 'cta', false);
        return container;
    }

}

customElements.define('nxt-document-list-item', NXTDocumentListItem);
